import React from 'react';
import _ from 'lodash';

export default function StorageImage(props) {
	const importedProps = _.pick(props, ['className', 'classes', 'alt', 'onerror']);
	return <img {...importedProps} src={`https://storage.googleapis.com/${props.src}`} alt="Billede" />;
}
